import { render, staticRenderFns } from "./CustomerCenterAdd.vue?vue&type=template&id=4a3ab3a4"
import script from "./CustomerCenterAdd.vue?vue&type=script&lang=js"
export * from "./CustomerCenterAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports